import styled from "styled-components";

const Container = styled.div`
  max-width: 1500px;
  padding: 2rem 1.5rem;
  margin: 0 auto;
`;

export default Container;
